/**
 * GA4 ecommerce events for SupaPress product pages.
 * Relies on site-wide gtag('config', 'G-…'); does not configure GA itself.
 */

function pushGa4Event(eventName, params) {
  if (typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", eventName, params);
}

function getProductPayload() {
  var el = document.getElementById("mr-ga4-product");
  if (!el) {
    return null;
  }

  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

function fireViewItem() {
  var payload = getProductPayload();
  if (!payload || !payload.items || !payload.items.length) {
    return;
  }

  pushGa4Event("view_item", {
    currency: payload.currency || "USD",
    value: Number(payload.value) || 0,
    items: payload.items,
  });
}

function itemFromBuyButton(button) {
  var price = parseFloat(button.getAttribute("data-ga-price"));
  if (isNaN(price)) {
    price = 0;
  }

  return {
    item_id: button.getAttribute("data-ga-item-id") || "",
    item_name: button.getAttribute("data-ga-item-name") || "",
    item_variant: button.getAttribute("data-ga-item-variant") || "",
    item_category: button.getAttribute("data-ga-item-category") || "",
    price: price,
    quantity: 1,
  };
}

function onBuyButtonClick(event) {
  var button = event.target.closest(".buy-button");
  if (!button || !button.getAttribute("data-ga-item-id")) {
    return;
  }

  var item = itemFromBuyButton(button);
  var currency = button.getAttribute("data-ga-currency") || "USD";

  pushGa4Event("add_to_cart", {
    currency: currency,
    value: item.price,
    items: [item],
  });
}

function initProductGa4() {
  if (!document.getElementById("mr-ga4-product")) {
    return;
  }

  fireViewItem();
  document.addEventListener("click", onBuyButtonClick);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductGa4);
} else {
  initProductGa4();
}
